import React, { useEffect, useState } from 'react';

import { ToolWrapper, FloatToolsDiv, OutPutWrapper } from './styled';
import { LivelensPage } from '@src/pages';
import EventLookerEasier from '../EventLookerEasier';
import { Button } from 'antd';
import EventLookerIcon from '@src/icons/home/home-exploration.svg';
import LivelensIcon from '@src/icons/livelens.svg';
import { CloseOutlined } from '@ant-design/icons';
import Validation from '@src/pages/workflow/components/Validation/Flow';
import { useFlowStore } from '@src/pages/workflow/store/flowBuilder';
import FlowOutput from '@src/emp-3.0/components/Metrics/Flow/FlowForm/FlowOutput';
import Deployment from '@src/pages/workflow/components/Deployment';
import { useExplorerStore } from '@src/pages/livelens/store';
import { useParams } from 'react-router-dom';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

const FloatToolsWrapper = () => {
  const [showFlowOutputs, setShowFlowOutputs] = useState(false);
  const { activeTool, setActiveTool, deploymentStatus, formInstance } = useFlowStore();
  const { resetLiveLensData } = useExplorerStore();
  const { type, id } = useParams();
  const { workbenchMode } = useInitialInfoStore();
  useEffect(() => {
    // clear livelens store
    return () => {
      resetLiveLensData();
    };
  }, []);

  // Dirty change to make Form.useWatch in FlowOutput work well.
  useEffect(() => {
    setTimeout(() => {
      if (formInstance) {
        setShowFlowOutputs(true);
      }
    }, 300);
  }, [id, formInstance]);

  useEffect(() => {
    // clear livelens store
    resetLiveLensData();
  }, [activeTool]);

  return (
    <div style={{ height: '100%', position: 'relative' }}>
      <FloatToolsDiv>
        <span>Tools to find events</span>
        <div>
          <Button
            title="Event Looker"
            style={{ height: 'fit-content', marginRight: '10px', padding: '6px 12px 0 12px' }}
            onClick={() => setActiveTool('eventlooker')}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '50px',
              }}
            >
              <EventLookerIcon style={{ fontSize: 20, margin: '4px 0 2px 0' }} />
              <span style={{ fontSize: '12px' }}>Event Looker</span>
            </div>
          </Button>
          {!workbenchMode && ( // only non-workbench mode can see livelens
            <Button
              title="LiveLens"
              style={{ height: 'fit-content', padding: '6px 12px 0 12px' }}
              onClick={() => setActiveTool('livelens')}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '50px',
                }}
              >
                <LivelensIcon style={{ fontSize: 20, margin: '4px 0 2px 0' }} />
                <span style={{ fontSize: '12px' }}>LiveLens</span>
              </div>
            </Button>
          )}
        </div>
      </FloatToolsDiv>

      {!activeTool && (type === 'flow' || type === 'pattern') && showFlowOutputs && (
        <OutPutWrapper>
          <FlowOutput />
        </OutPutWrapper>
      )}

      <ToolWrapper as={'div'} style={{ display: activeTool ? 'block' : 'none' }}>
        <div className={`tool-header ${activeTool !== 'eventlooker' ? 'right' : ''}`}>
          {activeTool === 'eventlooker' && (
            <div>
              <EventLookerIcon />
              <span>Event Looker</span>
            </div>
          )}
          <Button
            type="text"
            icon={<CloseOutlined />}
            disabled={deploymentStatus === 'inprogress'}
            onClick={() => {
              setActiveTool(null);
            }}
          />
        </div>
        {activeTool === 'eventlooker' && <EventLookerEasier />}
        {!workbenchMode && activeTool === 'livelens' && <LivelensPage pageType="embedded" />}
        {activeTool === 'validation' && <Validation />}
        {activeTool === 'deployment' && <Deployment />}
      </ToolWrapper>
    </div>
  );
};

export default FloatToolsWrapper;
